export enum ASSOCIATED_CONTENT_ERRORS {
  NON_EXISTENT_ASSOCIATED_CONTENT = 'form_associated_content_has_non_existent_content_error',
  NON_EXISTENT_CONTENT = 'form_associated_content_non_existent_content_error',
  CONTENT_REQUEST_ERROR = 'form_associated_content_request_error',
  GENERIC_ERROR = 'form_generic_error',
  NON_EXISTENT_MERCH_ASSOCIATED_CONTENT = 'form_merch_associated_content_non_existent_content_error',
}

export enum ENTITY_TYPE_ERRORS {
  GENERIC_ERROR = 'form_generic_error',
}
